import {
  admissionStatusLabels,
  decisionLabels,
  type AdmissionStatus,
  type Decision,
} from '@/entities/medical/model/medicalChecksSchema';

/** Цвета тегов статуса медосмотра — как в таблице (MedRecordsTab). */
export const medicalCheckStatusTagColor: Record<string, 'success' | 'warning' | 'error' | 'processing' | 'default'> = {
  passed: 'success',
  assigned: 'processing',
  in_progress: 'processing',
  overdue: 'error',
  failed: 'error',
  not_passed: 'error',
  not_assigned: 'default',
};

/** Цвета тегов допуска / решения — как в таблице (MedRecordsTab). */
export const medicalAdmissionTagColor: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
  fit: 'success',
  fit_with_restrictions: 'warning',
  temporary_unfit: 'error',
  permanent_unfit: 'error',
  allowed: 'success',
  not_allowed: 'error',
  allowed_with_restrictions: 'warning',
  temporary_not_allowed: 'error',
  permanent_not_allowed: 'error',
  not_assigned: 'default',
};

export function medicalDecisionOrAdmissionLabel(v: string): string {
  return decisionLabels[v as Decision] ?? admissionStatusLabels[v as AdmissionStatus] ?? v;
}
